import AdminSearchInput from 'components/AdminSearch/AdminSearchInput';
import PillTabs from 'components/tabs/PillTabs';
import useText from 'hooks/useText';

/**
 * The bar over the reviews, as the tasks' and the companies': « À traiter »
 * (with its count once read) and « Traités », then the search.
 */
const ReviewsToolbar = ({ tab, untreatedCount, query, onTab, onQuery }) => {
  const { text } = useText('reviews');
  return (
    <div className="flex shrink-0 flex-wrap items-center gap-4 px-4 py-3 lg:px-8">
      <PillTabs
        activeTab={tab}
        onChange={onTab}
        tabs={[
          { id: 'untreated', label: text('tabUntreated'), count: untreatedCount },
          { id: 'treated', label: text('tabTreated') },
        ]}
      />
      <div className="w-full tab:w-[260px]">
        <AdminSearchInput value={query} placeholder={text('search')} onChange={(event) => onQuery(event.target.value)} />
      </div>
    </div>
  );
};

export default ReviewsToolbar;
